import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import styles from './ArchiveSearchBox.module.scss';
import { CircledXIcon, MagnifyingGlassIcon } from '@repo/icons';
import Button from '@components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setArchiveSearchTerm } from '@repo/redux/actions/archive';
import { selectArchiveSearch } from '@repo/redux/reducers/data/archiveSearch';

export default function ArchiveSearchBox() {
  const dispatch = useDispatch();
  const archiveSearch = useSelector(selectArchiveSearch);
  const hasTerm = !!archiveSearch.term && archiveSearch.term !== 'all';
  const mountedRef = useRef(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [expanded, setExpanded] = useState(!!hasTerm);
  const [searchTerm, setSearchTerm] = useState(hasTerm ? archiveSearch.term : '');

  useEffect(() => {
    if (expanded && !!mountedRef.current) {
      inputRef.current?.focus();
    }

    if (!expanded) {
      setSearchTerm('');
    }
  }, [expanded]);

  useEffect(() => {
    dispatch(setArchiveSearchTerm(searchTerm));
  }, [searchTerm]);

  useEffect(() => {
    mountedRef.current = true;
  }, []);

  return (
    <div className={cn(styles.searchBox, expanded && styles.expanded)}>
      <label className={cn(styles.container)} id="search-input">
        <MagnifyingGlassIcon className={styles.icon} color="textSecondary" />
        <input
          type="text"
          ref={inputRef}
          className={styles.input}
          placeholder={'Search archive…'}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button tabIndex={-1} className={styles.clear} onClick={() => setExpanded(false)}>
          <CircledXIcon stroke="#434648" />
        </Button>
      </label>
      <Button className={styles.searchBtn} onClick={() => setExpanded(true)}>
        <MagnifyingGlassIcon width="20" height="20" hoverOpacity />
      </Button>
    </div>
  );
}
